import React, { useState } from 'react';
import KeywordsSection from './KeywordsSection';
import SimpleTagManager from './MasterTagKeyManagement';
import { Siren, Tag } from 'lucide-react';

const KeywordsAndTagsSection = ({
  keywords = [],
  newKeyword = '',
  setNewKeyword,
  handleAddKeyword,
  handleRemoveKeyword,
  isDarkMode,
  edgeServerEndpoint
}) => {
  const [activeTab, setActiveTab] = useState('keywords');

  const containerClasses = isDarkMode
    ? 'bg-gray-900/60 border-gray-800'
    : 'bg-white border-gray-200';

  return (
    <div className={`rounded-2xl shadow-lg p-4 md:p-6 transition-colors duration-300 border ${containerClasses}`}>
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-4">
          <div className={`p-3 rounded-2xl shadow-md ${isDarkMode ? 'bg-red-600' : 'bg-red-500'}`}>
            <Siren className="w-6 h-6 text-white" />
          </div>
          <div>
            <h2 className="text-2xl font-bold">Keywords & Tags</h2>
            <p className={`mt-1 text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
              Manage alert keywords and classification tags for your communications.
            </p>
          </div>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className={`border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
        <nav className="flex space-x-8" aria-label="Tabs">
          <button
            onClick={() => setActiveTab('keywords')}
            className={`
              flex items-center gap-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors
              ${activeTab === 'keywords'
                ? isDarkMode
                  ? 'border-blue-500 text-blue-400'
                  : 'border-blue-600 text-blue-600'
                : isDarkMode
                  ? 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }
            `}
          >
            <Siren className="w-5 h-5" />
            Keywords
          </button>
          <button
            onClick={() => setActiveTab('tags')}
            className={`
              flex items-center gap-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors
              ${activeTab === 'tags'
                ? isDarkMode
                  ? 'border-blue-500 text-blue-400'
                  : 'border-blue-600 text-blue-600'
                : isDarkMode
                  ? 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }
            `}
          >
            <Tag className="w-5 h-5" />
            Tags
          </button>
        </nav>
      </div>

      {/* Tab Content */}
      <div className="mt-4">
        {activeTab === 'keywords' && (
          <KeywordsSection
            keywords={keywords}
            newKeyword={newKeyword}
            setNewKeyword={setNewKeyword}
            handleAddKeyword={handleAddKeyword}
            handleRemoveKeyword={handleRemoveKeyword}
            isDarkMode={isDarkMode}
          />
        )}
        {activeTab === 'tags' && (
          <SimpleTagManager
            edgeServerEndpoint={edgeServerEndpoint}
            isDarkMode={isDarkMode}
          />
        )}
      </div>
    </div>
  );
};

export default KeywordsAndTagsSection;

